/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState, useContext } from "react";
import { useLocation } from 'react-router-dom';
import { Popover, Dropdown, Offcanvas, Modal } from "bootstrap";
import { EMOJI } from "./Emoji";
import { AppContext } from '../ApplicationContext';
import { txt } from './txt';
import { IFileUpload } from "./IFileUpload";
import { FileUploadGallery } from "./FileUploadGallery";
import { AudioRecorder } from "./AudioRecorder";
import { HelpContent } from "./HelpContent";
import { FileButton } from "./FileButton";

export interface IMessageListToolbarProps {
    
}


export interface IUploadSettings {
    
    title:string;
    fileTypes: string;

}

export const MESSAGE_PARAMETER : string = "mr[msg]";
export const SEND_PARAMETER : string = "mr[send]";

export const MessageListToolbar = (props: IMessageListToolbarProps) => {

    const context = useContext(AppContext);

    const location = useLocation();

    let params = new URLSearchParams(location.search);

    let autoSend : boolean = params.has(MESSAGE_PARAMETER) && params.has(SEND_PARAMETER) ? params.get(SEND_PARAMETER) === "true":false;

    useEffect(()=>{
    
        //console.log("AutoSend", {location:location, autoSend:autoSend});
        if(autoSend) {

            //clear the hash
            window.location.hash = "";
            onSendMessage(null);
            

        }

    });

    useEffect(()=>{
    
        setTimeout(()=> {/*console.log({effect:'enabling popover'});*/enablePopover('#btnEmojiPanel'); enablePopover('#btnAttachments'); enableOffcanvas()},100);
        

    },[]);

    
    const [emoji] = useState(EMOJI);

    const  groupBy = function (xs, key) {
        return xs.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    };

    const groups = groupBy(emoji, "groupName");
    
    

    const [message, setMessage] = useState(params.has(MESSAGE_PARAMETER) ? params.get(MESSAGE_PARAMETER):"");

    //const [showUploadPanel, setShowUploadPanel] = useState(props.isDraggingUpload);

    const [uploadSettings, setUploadSettings] = useState<IUploadSettings>({title:"", fileTypes:""});

    const executeAction = (action: string) => {
    
        //console.log({action:action});

        //setShowUploadPanel(true);

        switch(action){
        
            case "SendPhotoAndVideo":

                /*
                var e = document.getElementById('#pnlUpload');
                var pnlUpload : Offcanvas =  new Offcanvas('#pnlUpload',{backdrop:true});
                try{pnlUpload.show();}
                catch(err){}
                */
                var options = {};
                const dlgUpload = new Modal('#dlgUpload', options)
                dlgUpload.show();
                setUploadSettings({title:txt.get.uploadPhotosAndVideosDialogTitle, fileTypes: "image/jpg, image/png, video/mp4, video/mov"});

                setTimeout(()=> {
                    var input = (document.getElementById("inputFileUpload") as HTMLInputElement);
                    //input.file = "";
                    input.value = "";
                    
                }, 50);

                //Delayed to enable refresh uploadSettings in the dialog
               // setTimeout(()=> {
               //     $('#inputFileUpload').click();
               // }, 50);

                break;

            case "SendDocument":

                var options = {};
                const dlgUploadDoc = new Modal('#dlgUpload', options)
                dlgUploadDoc.show();
                setUploadSettings({title:txt.get.uploadDocumentDialogTitle, fileTypes: ".doc,.docx,.pdf,.xls,.xlsx,.ppt,.pptx"});
                setTimeout(()=> {
                      var input = (document.getElementById("inputFileUpload") as HTMLInputElement);
                    //input.file = "";
                    input.value = "";
                }, 50);
                //Delayed to enable refresh uploadSettings in the dialog
               // setTimeout(()=> {
               //     $('#inputFileUpload').click();
               // }, 50);
                

                break;

        }

         

    }

    const closeUploadDialog = ()=> {
    

        $('#btnCloseUploadDialog').click();

    }

    const enableOffcanvas = () => {
       //const offcanvasElementList : any = document.querySelectorAll('.offcanvas')
       //const offcanvasList = [...offcanvasElementList].map(offcanvasEl => {console.log({offcanvas: offcanvasEl}) ;return new Offcanvas(offcanvasEl,{backdrop:true})})
    }
     
        const onInsertEmoji = (e)=> {
         var text = ' ' + $(e.target).attr('data-mr-icon') + ' ';
                        var textarea = ( document.getElementById('txtMessage') as any);
                        let {selectionStart, selectionEnd} = textarea;
                        //console.log({textarea:textarea, text: text});
                         textarea.setRangeText(
                            text,
                            textarea.selectionStart,
                            textarea.selectionEnd,
                            'end'
                          );

                         
                         selectionStart += text.length -1;
                         selectionEnd += text.length-1;
                         setTextSelection({selectionStart, selectionEnd});
                         setMessage(textarea.value);
                         textarea.focus();
    }

     const enablePopover = (id) => {
        
            //console.log("enabling :"+ id);
            
            const popoverTriggerList: any = document.querySelectorAll(id);
            const popoverList = [...popoverTriggerList].map(popoverTriggerEl => { 
                //console.log({popover:popoverTriggerEl }); 

                popoverTriggerEl.addEventListener('inserted.bs.popover', () => {

                    $('[data-mr-icon]').off('click').on('click', (e)=> {
                        //console.log({icon:$(e.target).attr('data-mr-icon')});
                        var text = ' ' + $(e.target).attr('data-mr-icon') + ' ';
                        var textarea = ( document.getElementById('txtMessage') as any);
                        let {selectionStart, selectionEnd} = textarea;
                        //console.log({textarea:textarea, text: text});
                         textarea.setRangeText(
                            text,
                            textarea.selectionStart,
                            textarea.selectionEnd,
                            'end'
                          );

                         
                         selectionStart += text.length -1;
                         selectionEnd += text.length-1;
                         setTextSelection({selectionStart, selectionEnd});
                         setMessage(textarea.value);

                    });

                    $('[data-mr-action]').off('click').on('click', (e)=>{
                    
                        executeAction($(e.target).attr('data-mr-action'));


                    });

                });

                return new Popover(popoverTriggerEl,
                    {
                        offset:[100,10],
                        html:true,
                        trigger:'focus',
                        placement:'top', 
                        sanitize:false,
                        content: function() {

                             var content = $(this).attr("data-bs-content");
                             var html = $(content).children(".popover-body").html();
                           
                            return html;

                        },
                        title: function(){
                            var content = $(this).attr("data-bs-content");
                            var html = $(content).children(".popover-title").html();
                           
                            return html;
                        }
                });
            });

        }

    const onSendMessage =  (e)=> {
        
        //console.log("onSendMessage",{message:message});
        if( (!message || message==="" ) && (fileUploads ===null || fileUploads.length === 0))
        {
            return;
        }

        try {
              if(fileUploads && fileUploads.length>0) {
            
                context.messenger.sendMedia(message, fileUploads[0]);

            } else {
                
                context.messenger.sendMessage(message);

            }

            
        
            setMessage("");
            setFileUploads([]);
        } catch (err) {
            console.error(err);
        
         } 


    }

    //https://www.smashingmagazine.com/2018/01/drag-drop-file-uploader-vanilla-js/

    const [uploadDragState, setUploadDragState] = useState("")

    
    const onUploadDragEnter = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setUploadDragState('upload-drag-over');
    }
    const onUploadDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setUploadDragState('');
    }
    const onUploadDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setUploadDragState('upload-drag-over');
    }
    const onUploadDragDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        let dt = e.dataTransfer
        let files = dt.files

        DoUploadFiles(files)
    }

    const onHandleFiles = (e) => {
        // e.preventDefault();
        // e.stopPropagation();

        console.log({onHandleFiles:e});

        DoUploadFiles(e.target.files);
    }

    const DoUploadFiles = (m) => {

        closeUploadDialog();

        var add:IFileUpload[] = [...m].filter( f => fileUploads.filter( fu => (fu.LocalFile.name === f.name && fu.LocalFile.lastModified === f.lastModified) ).length === 0 ).map( (n) => {return {LocalFile:n};} );

        var newFileUploads = [...fileUploads,...add];
        console.log({newFileUploads:newFileUploads});
        setFileUploads(newFileUploads);
        
    }


    const [fileUploads, setFileUploads] = useState<IFileUpload[]>([]);

    const onDeleteFileUpload = (d:IFileUpload) => {

        var newFileUploads = [...fileUploads.filter( m => {var result = (m.LocalFile.name !== d.LocalFile.name) && (m.LocalFile.lastModified !== d.LocalFile.lastModified); console.log({m:m.LocalFile.name, d:d.LocalFile.name, filter: result}); return result; })]
        console.log({onDeleteFileUpload:d, fileUploads: fileUploads, newFileUploads:newFileUploads});
        setFileUploads( newFileUploads );

    }


    const onAudioRecordingStart = () => {
        $(".hidden-on-audio-recording").hide();
        $('#audioRecorderContainer').removeClass("col-auto").addClass('col');
    }
    
    const onAudioRecordingEnd = () => {
        
        $('#audioRecorderContainer').addClass("col-auto").removeClass('col');
        $(".hidden-on-audio-recording").show();
    }
    
    
    const onTextboxKeyUp= (e) => {
    //DOEs NOT WORK ON MOBILE :: https://stackoverflow.com/questions/75911453/shiftenter-javascript-event-is-there-a-bug-on-android-stock-keyboard
        //console.log("onTextboxKeyUp",{e:e, modifier:e.getModifierState("Shift")});
        if((e.keyCode||e.which) == 13  /*&& !(e.shiftKey||e.getModifierState("Shift"))*/) {

            e.preventDefault();
            e.stopPropagation();
            onSendMessage(e);
            
        }

    }

    const [textSelection, setTextSelection] = useState<null|{selectionStart, selectionEnd}>(null);

    useEffect(()=> {
    
        if(textSelection) {
            var textarea = ( document.getElementById('txtMessage') as any);
            textarea.setSelectionRange(textSelection.selectionStart,textSelection.selectionEnd);
            setTextSelection(null);
            textarea.focus();
        }
         

    },[textSelection])

    const onClickInsertEnter = (e) => {

        let text: string = '\r\n';

        var textarea = ( document.getElementById('txtMessage') as any);
        let {selectionStart, selectionEnd} = textarea;
        textarea.setRangeText(
        text,
        textarea.selectionStart,
        textarea.selectionEnd,
        'end'
        );

        selectionStart += text.length -1;
        selectionEnd += text.length-1;
        setTextSelection({selectionStart, selectionEnd});
        setMessage(textarea.value);


    }

    useEffect(()=> {$("#txtMessage").attr("enterKeyHint","send")},[]);
  


    useEffect(()=>{
    
        const offcanvasElementList : any = document.querySelectorAll('.offcanvas')
        const offcanvasList = [...offcanvasElementList].map(offcanvasEl => new Offcanvas(offcanvasEl))

    }, []);

    const [showHelp, setShowHelp] = useState(false);

        const onSelectMedia = (e) => {
    
        console.log("onSelectMedia",{e:e, files:e.target.files,  value: e.target.value});
        
        $('#btnCloseUpload').click();

        //setFileUploads(e.target.files);
        DoUploadFiles(e.target.files);

    }

    return <>
    

                        <div className="offcanvas offcanvas-bottom mr-help-panel mr-messagelist-toolbar-panel" data-bs-scroll="true" data-bs-backdrop="false" tabIndex={-1} id="help" aria-labelledby="HelpPanelLabel" >
                          <div className="offcanvas-header mr-messenger-content-area-width container-fluid">
                            <h5 className="offcanvas-title" id="HelpPanelLabel">Help</h5>
                            <button id="btnCloseHelp" type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                          </div>
                          <div id='helpPanel' className="offcanvas-body mr-messenger-content-area container-fluid" style={{overflow:"hidden"}}>
                            {showHelp && <HelpContent url={context.messenger.connection.settings.helpUrl}/> }
                          </div>
                        </div>
    
                        <div className="offcanvas offcanvas-bottom mr-upload-panel mr-messagelist-toolbar-panel" data-bs-scroll="true" data-bs-backdrop="false" tabIndex={-1} id="upload" aria-labelledby="UploadPanelLabel" >
                          <div className="offcanvas-header mr-messenger-content-area-width container-fluid">
                            <h5 className="offcanvas-title" id="UploadPanelLabel">Share</h5>
                            <button id="btnCloseUpload" type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                          </div>
                          <div className="offcanvas-body mr-messenger-content-area container-fluid">
                              <div className="container">
        
                                    {/*<div className="btn btn-lg btn-primary mr-messenger-file-button"><label><i className="bi bi-camera"/></label></div>*/}

                                    <FileButton multiple={false} accept={context.messenger.connection.settings.mimeTypes.video} onSelect={onSelectMedia}><i className="bi bi-file-play"></i><span>Video</span></FileButton>
                                    <FileButton multiple={false} accept={context.messenger.connection.settings.mimeTypes.image} onSelect={onSelectMedia}><i className="bi bi-file-image"/><span>Foto</span></FileButton>
                                    <FileButton multiple={false} accept={context.messenger.connection.settings.mimeTypes.audio} onSelect={onSelectMedia}><i className="bi bi-file-music"/><span>Audio</span></FileButton>
                                    <FileButton multiple={false} accept={context.messenger.connection.settings.mimeTypes.document} onSelect={onSelectMedia}><i className="bi bi-file-richtext"/><span>File</span></FileButton>
                                    <FileButton multiple={false} accept={context.messenger.connection.settings.mimeTypes.sticker} onSelect={onSelectMedia}><i className="bi bi-person-square"/><span>Sticker</span></FileButton>

                              </div>
                          </div>
                        </div>

                        {/*
                        <div className="offcanvas offcanvas-bottom mr-messagelist-toolbar-panel"  data-bs-scroll="true" data-bs-backdrop="false" tabIndex={-1} id="emoji" aria-labelledby="EmojiPanelLabel" >
                            <div className="offcanvas-header mr-messenger-content-area-width container-fluid">
                            <h5 className="offcanvas-title" id="EmojiPanelLabel">Emoji</h5>
                            <button id="btnCloseEmoji" type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                            </div>
                            <div className="offcanvas-body mr-messenger-content-area container-fluid" >
                            {Object.keys(groups).sort().map(groupName => {

                                    var name = groupName === undefined ? "Other" : groupName;

                                    var group = groups[groupName];

                                    return <div key={groupName} style={{ marginTop: 0 }}><span key={groupName + '-1'}>&nbsp;</span><div key={groupName + '-2'} >{group.map(n => <span key={ n.code } style={{ fontSize: 24, textDecoration:'none',cursor:'pointer' }}  data-mr-icon={n.icon} onClick={onInsertEmoji}>{n.icon}</span>)}</div></div>

                                })}
                            </div>
                        </div>
    */}

        <div 
            className="container-fluid mr-message-list-toolbar mr-message-list-toolbar-content"
            >
        
            <div 
                className="row g-2 g-lg-4 align-items-center justify-content-center"
                >
        
                {/*
                <div 
                    className="col-auto hidden-on-audio-recording"
                    style={{display:"none"}}
                    >

                                        
                    <div className="btn-group btn-group-vertical mr-message-list-toolbar-button-block">
                    
                     <div 
                        className="btn-group" 
                        role="group"
                        >

                        <button 
                            id="btnHelp"
                            className="btn btn-secondary"
                             data-bs-toggle="offcanvas" data-bs-target="#help" aria-controls="help"
                             onClick={(e)=>{ let showing = $('#help').hasClass('show');setShowHelp(!showing);}}
                            >
                            <i className="bi bi-question-circle"/>
                        </button>
                        <button
                             id="btnEmojiPanel" 
                             className="btn btn-secondary" 
                             data-bs-toggle="popover" 
                             data-bs-content="#pnlEmoji"
                             data-bs-placement="top"
                             data-bs-html="true"
                             //data-bs-toggle="offcanvas" 
                             //data-bs-target="#emoji" 
                             //aria-controls="emoji"
                             //onClick={onOpenEmojiPanel}
                             >
                                <i className="bi bi-emoji-smile"/>
                        </button>
                    </div>

                    <div 
                        className="btn-group" 
                        role="group"
                        >

                        <button
                            id="btnAttachments" 
                            className="btn btn-secondary" 
                            //data-bs-toggle="popover" 
                            //data-bs-content="#pnlAttachments"
                            //data-bs-placement="top"
                            //data-bs-html="true"
                            data-bs-toggle="offcanvas" 
                             data-bs-target="#upload" 
                             aria-controls="upload"
                             onMouseDown={(e)=> setFileUploads([]) } 
                            
                            >
                                <i className="bi bi-paperclip"/>
                        </button>

                         <button
                            id="btnInsertEnter"
                            className="btn btn-secondary" 
                            onClick={onClickInsertEnter}
                            title="Start een nieuwe regel in je bericht"
                            >
                                <i className="bi bi-arrow-return-left"></i>
                            </button>

                    </div>
                    </div> {/* /btn-group-vertical  

                    </div>{/* /col  

                    */}

                    <div
                        className="col hidden-on-audio-recording"
                        
                        >
                
                       

                        

                          {(fileUploads.length > 0) && <FileUploadGallery 
                                                            files={ fileUploads } 
                                                            onDelete={onDeleteFileUpload} 
                                                            /> }

                         <textarea 
                            id="txtMessage" 
                            className="form-control" 
                            rows={2} 
                            value={message} 
                            placeholder={txt.get.placeholderTypeAMessage} 
                            maxLength={5000} 
                            onChange={(e)=> { setMessage(e.target.value)} }
                            onKeyUp={onTextboxKeyUp}
                            
                            ></textarea>
                            <div className="mr-messenger-toolbar-inline">
                            

                             <button
                                id="btnInsertEnter"
                                className="btn btn-lg" 
                                onClick={onClickInsertEnter}
                                title="Start een nieuwe regel in je bericht"
                                >
                                    <i className="bi bi-arrow-return-left"></i>
                                </button>

                             <button
                                id="btnAttachments" 
                                className="btn btn-lg" 
                                data-bs-toggle="offcanvas" 
                                data-bs-target="#upload" 
                                aria-controls="upload"
                                onMouseDown={(e)=> {setFileUploads([]);} } 
                                
                                >
                                    <i className="bi bi-paperclip"/>
                            </button>

                             </div>
                    </div>
                   
                    <div 
                        id="audioRecorderContainer"
                        className="col-auto"
                        >
                         {(message !== "" || !(fileUploads === null || fileUploads.length === 0) ) && <button id="btnSend" className="btn btn-primary" onClick={ (e)=> onSendMessage(e) } title="Enter: Stuur het berichtje, gebruik de enter knop om een nieuwe regel te starten" ><i className="bi bi-send"/></button>}
                         {message === "" && (fileUploads === null || fileUploads.length === 0)  && <AudioRecorder  onRecordingStart={onAudioRecordingStart} onRecordingEnd={onAudioRecordingEnd} />}
                    </div>

                </div> {/*row*/}
    </div> {/*container*/}

     <div className="hidden" id="pnlEmoji">
      <div className="popover-title">
        
      </div>

      <div className="popover-body">
        <div className="mr-emoji-panel">
         {Object.keys(groups).sort().map(groupName => {

                var name = groupName === undefined ? "Other" : groupName;

                var group = groups[groupName];

                return <div key={groupName} style={{ marginTop: 0 }}><span key={groupName + '-1'}>&nbsp;</span><div key={groupName + '-2'} >{group.map(n => <span key={ n.code } style={{ fontSize: 24, textDecoration:'none',cursor:'pointer' }}  data-mr-icon={n.icon}>{n.icon}</span>)}</div></div>

            })}
         </div>
      </div> 
    </div>

    {/*
    <div className="offcanvas offcanvas-top mr-help-panel" data-bs-scroll="true" data-bs-backdrop="false" tabIndex={-1} id="help" aria-labelledby="offcanvasScrollingLabel" >
      <div className="offcanvas-header mr-messenger-content-area-width container-fluid">
        <h5 className="offcanvas-title" id="offcanvasScrollingLabel">Help</h5>
        <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>
      <div className="offcanvas-body mr-messenger-content-area container-fluid" style={{overflow:"hidden"}}>
        <HelpContent url={context.messenger.connection.settings.helpUrl}/>
      </div>
    </div>


    <div className="hidden" id="pnlAttachments">

         <div className="popover-title">
            {txt.get.menuSend}
          </div>

          <div className="popover-body">

            <div className="list-group">
          
              <button type="button" className="list-group-item list-group-item-action" data-mr-action="SendPhotoAndVideo" >{txt.get.buttonSendPhotosAndVideos}</button>
              <button type="button" className="list-group-item list-group-item-action" data-mr-action="SendCamera">{txt.get.buttonSendCamera}</button>
              <button type="button" className="list-group-item list-group-item-action" data-mr-action="SendDocument">{txt.get.buttonSendDocument}</button>
          
            </div>

          </div>

    </div>
    
    <div className="hidden" id="pnlEmoji">
      <div className="popover-title">
        
      </div>

      <div className="popover-body">
        <div className="mr-emoji-panel">
         {Object.keys(groups).sort().map(groupName => {

                var name = groupName === undefined ? "Other" : groupName;

                var group = groups[groupName];

                return <div key={groupName} style={{ marginTop: 0 }}><span key={groupName + '-1'}>&nbsp;</span><div key={groupName + '-2'} >{group.map(n => <span key={ n.code } style={{ fontSize: 24, textDecoration:'none',cursor:'pointer' }}  data-mr-icon={n.icon}>{n.icon}</span>)}</div></div>

            })}
         </div>
      </div> 
    </div>



<div className="modal modal-xl modal-dialog-centered  fade" id="dlgUpload" tabIndex={-1} aria-labelledby="lblUpload" aria-hidden="true" style={{display:'none'}}>
  <div className="modal-dialog">
    <div className="modal-content">
      <div className="modal-header">
        <h1 className="modal-title fs-5" id="lblUpload">{uploadSettings.title}</h1>
        <button id="btnCloseUploadDialog" type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
        <div 
            className={ "upload-dropzone " + uploadDragState  }  
            onDragEnter={onUploadDragEnter}
            onDragLeave={onUploadDragLeave}
            onDragOver={onUploadDragOver}
            onDrop={onUploadDragDrop}
            >
        <div className="container text-center">
             <div className="row align-items-center">
                
                <div className="col">
                    <div className="upload-dropzone-form">
                        <span>{uploadDragState === 'upload-drag-over'?  txt.get.dropzoneDropHereNow: txt.get.dropzoneDropHere}</span>
                        <div className="mb-3">
                          <input className="form-control" type="file" id="inputFileUpload" multiple accept={uploadSettings.fileTypes} onChange={onHandleFiles}/>
                        </div>
                    </div>
                </div>
              
            </div>
        </div>
       
     
           
        </div>
      </div>

    </div>
  </div>
</div>
   */}
    </>

}